/**
 * @fileoverview gRPC-Web generated client stub for witbooking.loyalty.customer.v1
 * @enhanceable
 * @public
 */

// GENERATED CODE -- DO NOT EDIT!



const grpc = {};
grpc.web = require('grpc-web');


var validate_validate_pb = require('../../../../validate/validate_pb.js')

var witbooking_backoffice_common_common_pb = require('../../../../witbooking/backoffice/common/common_pb.js')

var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js')

var google_type_money_pb = require('../../../../google/type/money_pb.js')

var witbooking_loyalty_shared_tier_pb = require('../../../../witbooking/loyalty/shared/tier_pb.js')
const proto = {};
proto.witbooking = {};
proto.witbooking.loyalty = {};
proto.witbooking.loyalty.customer = {};
proto.witbooking.loyalty.customer.v1 = require('./customer_api_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?Object} options
 * @constructor
 * @struct
 * @final
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options['format'] = 'binary';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname;

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerResponse>}
 */
const methodDescriptor_CustomerAPI_GetCustomer = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/GetCustomer',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.GetCustomerRequest,
  proto.witbooking.loyalty.customer.v1.GetCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.GetCustomerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerResponse>}
 */
const methodInfo_CustomerAPI_GetCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.GetCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.GetCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.GetCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.GetCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.getCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_GetCustomer,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.GetCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.getCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/GetCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_GetCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest,
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse>}
 */
const methodDescriptor_CustomerAPI_GetCustomerByAuthenticationServiceId = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/GetCustomerByAuthenticationServiceId',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest,
  proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest,
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse>}
 */
const methodInfo_CustomerAPI_GetCustomerByAuthenticationServiceId = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.getCustomerByAuthenticationServiceId =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/GetCustomerByAuthenticationServiceId',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_GetCustomerByAuthenticationServiceId,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.GetCustomerByAuthenticationServiceIdResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.getCustomerByAuthenticationServiceId =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/GetCustomerByAuthenticationServiceId',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_GetCustomerByAuthenticationServiceId);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.ListCustomersRequest,
 *   !proto.witbooking.loyalty.customer.v1.ListCustomersResponse>}
 */
const methodDescriptor_CustomerAPI_ListCustomers = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/ListCustomers',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.ListCustomersRequest,
  proto.witbooking.loyalty.customer.v1.ListCustomersResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.ListCustomersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.ListCustomersRequest,
 *   !proto.witbooking.loyalty.customer.v1.ListCustomersResponse>}
 */
const methodInfo_CustomerAPI_ListCustomers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.ListCustomersResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.ListCustomersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.ListCustomersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.ListCustomersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.listCustomers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/ListCustomers',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_ListCustomers,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.ListCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.ListCustomersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.listCustomers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/ListCustomers',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_ListCustomers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.CreateCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.CreateCustomerResponse>}
 */
const methodDescriptor_CustomerAPI_CreateCustomer = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/CreateCustomer',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.CreateCustomerRequest,
  proto.witbooking.loyalty.customer.v1.CreateCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.CreateCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.CreateCustomerResponse>}
 */
const methodInfo_CustomerAPI_CreateCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.CreateCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.CreateCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.CreateCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.CreateCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.createCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/CreateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_CreateCustomer,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.CreateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.CreateCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.createCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/CreateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_CreateCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest,
 *   !proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse>}
 */
const methodDescriptor_CustomerAPI_CustomerRegistration = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/CustomerRegistration',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest,
  proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest,
 *   !proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse>}
 */
const methodInfo_CustomerAPI_CustomerRegistration = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.customerRegistration =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/CustomerRegistration',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_CustomerRegistration,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.CustomerRegistrationRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.CustomerRegistrationResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.customerRegistration =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/CustomerRegistration',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_CustomerRegistration);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse>}
 */
const methodDescriptor_CustomerAPI_UpdateCustomer = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/UpdateCustomer',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest,
  proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse>}
 */
const methodInfo_CustomerAPI_UpdateCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.updateCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/UpdateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_UpdateCustomer,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.UpdateCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.UpdateCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.updateCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/UpdateCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_UpdateCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse>}
 */
const methodDescriptor_CustomerAPI_DeleteCustomer = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/DeleteCustomer',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest,
  proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse>}
 */
const methodInfo_CustomerAPI_DeleteCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.deleteCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/DeleteCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_DeleteCustomer,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.DeleteCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.DeleteCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.deleteCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/DeleteCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_DeleteCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse>}
 */
const methodDescriptor_CustomerAPI_AssignConstantTierAndReferrerToCustomer = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/AssignConstantTierAndReferrerToCustomer',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest,
  proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse>}
 */
const methodInfo_CustomerAPI_AssignConstantTierAndReferrerToCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.assignConstantTierAndReferrerToCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/AssignConstantTierAndReferrerToCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_AssignConstantTierAndReferrerToCustomer,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.AssignConstantTierAndReferrerToCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.assignConstantTierAndReferrerToCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/AssignConstantTierAndReferrerToCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_AssignConstantTierAndReferrerToCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse>}
 */
const methodDescriptor_CustomerAPI_GetImpersonatedCustomer = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/GetImpersonatedCustomer',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest,
  proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse>}
 */
const methodInfo_CustomerAPI_GetImpersonatedCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.getImpersonatedCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/GetImpersonatedCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_GetImpersonatedCustomer,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.GetImpersonatedCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.getImpersonatedCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/GetImpersonatedCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_GetImpersonatedCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse>}
 */
const methodDescriptor_CustomerAPI_ChangeStatusCustomer = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/ChangeStatusCustomer',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest,
  proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse>}
 */
const methodInfo_CustomerAPI_ChangeStatusCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.changeStatusCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/ChangeStatusCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_ChangeStatusCustomer,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.ChangeStatusCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.changeStatusCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/ChangeStatusCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_ChangeStatusCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest,
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse>}
 */
const methodDescriptor_CustomerAPI_GetCustomerTierInfo = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/GetCustomerTierInfo',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest,
  proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest,
 *   !proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse>}
 */
const methodInfo_CustomerAPI_GetCustomerTierInfo = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.getCustomerTierInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/GetCustomerTierInfo',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_GetCustomerTierInfo,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.GetCustomerTierInfoResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.getCustomerTierInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/GetCustomerTierInfo',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_GetCustomerTierInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest,
 *   !proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse>}
 */
const methodDescriptor_CustomerAPI_CalculateCustomerTier = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/CalculateCustomerTier',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest,
  proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest,
 *   !proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse>}
 */
const methodInfo_CustomerAPI_CalculateCustomerTier = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.calculateCustomerTier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/CalculateCustomerTier',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_CalculateCustomerTier,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.CalculateCustomerTierResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.calculateCustomerTier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/CalculateCustomerTier',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_CalculateCustomerTier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest,
 *   !proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse>}
 */
const methodDescriptor_CustomerAPI_UpgradeCustomerTier = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/UpgradeCustomerTier',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest,
  proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest,
 *   !proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse>}
 */
const methodInfo_CustomerAPI_UpgradeCustomerTier = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.upgradeCustomerTier =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/UpgradeCustomerTier',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_UpgradeCustomerTier,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.UpgradeCustomerTierResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.upgradeCustomerTier =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/UpgradeCustomerTier',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_UpgradeCustomerTier);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse>}
 */
const methodDescriptor_CustomerAPI_ActivateBookAndJoinCustomer = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/ActivateBookAndJoinCustomer',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest,
  proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest,
 *   !proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse>}
 */
const methodInfo_CustomerAPI_ActivateBookAndJoinCustomer = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.activateBookAndJoinCustomer =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/ActivateBookAndJoinCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_ActivateBookAndJoinCustomer,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.ActivateBookAndJoinCustomerResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.activateBookAndJoinCustomer =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/ActivateBookAndJoinCustomer',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_ActivateBookAndJoinCustomer);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest,
 *   !proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse>}
 */
const methodDescriptor_CustomerAPI_ClearTempCustomers = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/ClearTempCustomers',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest,
  proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest,
 *   !proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse>}
 */
const methodInfo_CustomerAPI_ClearTempCustomers = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.clearTempCustomers =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/ClearTempCustomers',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_ClearTempCustomers,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.ClearTempCustomersRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.ClearTempCustomersResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.clearTempCustomers =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/ClearTempCustomers',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_ClearTempCustomers);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailRequest,
 *   !proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailResponse>}
 */
const methodDescriptor_CustomerAPI_FindCustomerByBrandIdAndEmail = new grpc.web.MethodDescriptor(
  '/witbooking.loyalty.customer.v1.CustomerAPI/FindCustomerByBrandIdAndEmail',
  grpc.web.MethodType.UNARY,
  proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailRequest,
  proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailResponse.deserializeBinary
);


/**
 * @const
 * @type {!grpc.web.AbstractClientBase.MethodInfo<
 *   !proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailRequest,
 *   !proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailResponse>}
 */
const methodInfo_CustomerAPI_FindCustomerByBrandIdAndEmail = new grpc.web.AbstractClientBase.MethodInfo(
  proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailResponse,
  /**
   * @param {!proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailResponse.deserializeBinary
);


/**
 * @param {!proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.Error, ?proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailResponse)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailResponse>|undefined}
 *     The XHR Node Readable Stream
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIClient.prototype.findCustomerByBrandIdAndEmail =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/FindCustomerByBrandIdAndEmail',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_FindCustomerByBrandIdAndEmail,
      callback);
};


/**
 * @param {!proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.witbooking.loyalty.customer.v1.FindCustomerByBrandIdAndEmailResponse>}
 *     A native promise that resolves to the response
 */
proto.witbooking.loyalty.customer.v1.CustomerAPIPromiseClient.prototype.findCustomerByBrandIdAndEmail =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/witbooking.loyalty.customer.v1.CustomerAPI/FindCustomerByBrandIdAndEmail',
      request,
      metadata || {},
      methodDescriptor_CustomerAPI_FindCustomerByBrandIdAndEmail);
};


module.exports = proto.witbooking.loyalty.customer.v1;

